import {
    jStorageKeys,
    localStorageKeys,
    REACT_STORAGE_AUTH_KEY
} from '~/common/storage.constants';
import { JStorageService } from '~/services/j-storage.service';
import type { User } from '~/models/user.model';
import type { IUserResponse } from '~/types/server.types';

export function saveUserToLocalStorage({
    user,
    jStorageService
}: {
    user: IUserResponse;
    jStorageService: JStorageService;
}) {
    setUserInLocalStorage(user);
    jStorageService.set(jStorageKeys.CURR_USER, user);
    jStorageService.set(jStorageKeys.API_VERSION, user.api_version);
    jStorageService.set(jStorageKeys.AUTH_TOKEN, user.authentication_token);
    jStorageService.set(jStorageKeys.AUTH_USER_ID, user._id);
    if (user.trusted_device) {
        jStorageService.set(jStorageKeys.TRUSTED_DEVICE, user.trusted_device);
    }

    if (user.email) {
        localStorage.setItem(
            localStorageKeys.HB_USER_DETAILS,
            JSON.stringify({
                email: user.email,
                first_name: user.first_name,
                last_name: user.last_name,
                full_name: user.full_name
            })
        );
    }
}

export function setUserInLocalStorage(user: IUserResponse) {
    localStorage.setItem(REACT_STORAGE_AUTH_KEY, JSON.stringify(user));
}

export function getUserFromLocalStorage() {
    return JSON.parse(
        localStorage.getItem(REACT_STORAGE_AUTH_KEY)
    ) as IUserResponse;
}

export function updateUserInStorage(storage: JStorageService, user: User) {
    const userResponse = user.toUserResponse();
    saveUserToLocalStorage({ user: userResponse, jStorageService: storage });
}

export function clearUserFromStorage(storage: JStorageService) {
    storage.deleteKey(jStorageKeys.CURR_USER);
    storage.deleteKey(jStorageKeys.API_VERSION);
    storage.deleteKey(jStorageKeys.AUTH_TOKEN);
    storage.deleteKey(jStorageKeys.AUTH_USER_ID);
}
